import React from 'react'
import appConfig from '../config/AppConfig'

const EnvironmentDiagnostic: React.FC = () => {
  const envVars = {
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    VITE_WS_URL: import.meta.env.VITE_WS_URL,
    VITE_DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE,
    VITE_APP_NAME: import.meta.env.VITE_APP_NAME
  }

  const appConfigValues = {
    apiBaseUrl: appConfig.apiBaseUrl,
    apiLocalUrl: appConfig.apiLocalUrl,
    apiAdminUrl: appConfig.apiAdminUrl,
    wsUrl: appConfig.wsUrl,
    debugMode: appConfig.debugMode,
    appName: appConfig.appName
  }

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      background: 'rgba(0,0,0,0.9)', 
      color: 'white', 
      padding: '20px', 
      zIndex: 9999,
      fontSize: '12px',
      maxHeight: '100vh',
      overflow: 'auto'
    }}>
      <h3>🔍 Environment Diagnostic</h3>
      
      <h4>Raw Environment Variables:</h4>
      <pre>{JSON.stringify(envVars, null, 2)}</pre>
      
      <h4>AppConfig Values:</h4>
      <pre>{JSON.stringify(appConfigValues, null, 2)}</pre>
      
      <h4>Current URL:</h4>
      <pre>{window.location.href}</pre>
      
      <h4>localStorage:</h4>
      <pre>{JSON.stringify(
        Object.keys(localStorage).reduce((acc, key) => {
          acc[key] = localStorage.getItem(key)
          return acc
        }, {} as Record<string, string | null>), 
        null, 
        2
      )}</pre>
      
      <button 
        onClick={() => {
          localStorage.clear()
          sessionStorage.clear()
          window.location.reload()
        }}
        style={{ 
          padding: '10px', 
          background: 'red', 
          color: 'white', 
          border: 'none',
          marginTop: '10px'
        }}
      >
        Clear All Storage & Reload
      </button>
    </div>
  )
}

export default EnvironmentDiagnostic
